import {Action, createReducer, on} from '@ngrx/store';
import {CollectionsFilterInterface} from '../../interfaces/collections-filter.interface';
import {
  CollectCollectionsFilters,
  ResetCollectionsFilters,
  SelectCollectionsCategories,
  SelectLetter
} from '../actions/collections-filter.actions';

const collectionsFilter: CollectionsFilterInterface = {
  filterActive: false,
  tags: {
    collectionCategories: {
      Crockery: true,
      Glassware: true,
      Cutlery: true,
      Gifts: true,
      Decoration: true,
      Serving: true,
      Baking: true,
      Kids: true,
      Novelties: true,
      Xmas: true,
      Easter: true,
    },
    alphabet: {
      letter: ''
    }
  },
  activeFilterCollection: {
    categories: []
  }
};

const reducer = createReducer(
  collectionsFilter,
  on(SelectCollectionsCategories, (state, value) => ({
        ...state,
        tags: {
          ...state.tags,
          collectionCategories: value,
        }
      }
    )
  ),
  on(SelectLetter, (state, value) => ({
        ...state,
        tags: {
          ...state.tags,
          alphabet: value
        }
      }
    )
  ),
  on(CollectCollectionsFilters, (state, value) => ({
        ...state,
        activeFilterCollection: value,
      }
    )
  ),
  on(ResetCollectionsFilters, () => (
      collectionsFilter
    )
  ),
);

export const CollectionsFilterReducer = (state: any, action: Action) => reducer(state, action);
